import React from "react";
import { useSearch } from "../context/search";
import Layout from "../components/Layout/Layout";
const Search = () => {
  const [values, setValues] = useSearch();
  return (
    <Layout title={"Search results"}>
      <div className="container">
        <div className="text-center">
          <h2>Search Results</h2>
          <h6>
            {values?.results.length < 1
              ? "No Products Found"
              : ` Found ${values?.results.length}`}
          </h6>

          <div className="d-flex flex-wrap  justify-content">
            {values?.results.map((item) => (
              <div
                className="card m-2"
                key={item._id}
                style={{ width: "18rem" }}
              >
                <img
                  src={`/api/v1/product/product-photo/${item._id}`}
                  className="card-img-top"
                  alt={item.name}
                />

                <div className="card-body">
                  <h5 className="card-title">{item.name}</h5>
                  <p className="card-text">
                    {item.description.substring(0, 30)}
                  </p>
                  <p className="card-text">RS.{item.price}</p>

                  <a href="#" className="btn btn-primary ms-1">
                    More{" "}
                  </a>
                  <a href="#" className="btn btn-secondary ms-1">
                    {" "}
                    Cart
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Search;
